import './common/utils/ErrorHandler';
import Vue from 'vue';
import iView from 'iview';
import App from './App.vue';
import router from '@/router';
import store from '@/vuex/store';
import VueClipboard from 'vue-clipboard2';
import VueLocalStorage from 'vue-localstorage';


Vue.config.productionTip = false;
Vue.use(iView, {
  transfer: true,
});
Vue.use(VueLocalStorage);

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
